import { render } from "./examquestions.vue?vue&type=template&id=62dd96f2&scoped=true&ts=true"
import script from "./examquestions.vue?vue&type=script&lang=ts"
export * from "./examquestions.vue?vue&type=script&lang=ts"

import "./examquestions.vue?vue&type=style&index=0&id=62dd96f2&scoped=true&lang=scss"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dd96f2"]])

export default __exports__